/**
 * Error normalizado del API. Se construye en el interceptor de respuesta
 * de Axios para que los consumidores (mutations, queries) tengan siempre
 * la misma forma sin importar el origen del fallo.
 *
 * Ver formato de error en convenciones §5.2.
 */
export class ApiError extends Error {
  readonly code: string;
  readonly httpStatus: number;
  readonly details: Record<string, unknown> | undefined;
  readonly requestId: string | undefined;

  constructor(args: {
    code: string;
    message: string;
    httpStatus: number;
    details?: Record<string, unknown>;
    requestId?: string;
  }) {
    super(args.message);
    this.name = "ApiError";
    this.code = args.code;
    this.httpStatus = args.httpStatus;
    this.details = args.details;
    this.requestId = args.requestId;
  }

  static esApiError(value: unknown): value is ApiError {
    return value instanceof ApiError;
  }

  static red(): ApiError {
    return new ApiError({
      code: "ERROR_RED",
      message: "No se pudo contactar al servidor. Verifica tu conexión.",
      httpStatus: 0,
    });
  }
}
